<template>
  <div class="CrowdfundingProjectWidget">
    <div class="d-flex flex-direction-column flex-direction-md-row justify-content-md-between">
      <div class="imgWrapper">
        <a :href="link" target="_blank">
          <img :src="image" :alt="title" />
        </a>
      </div>
      <div class="infoWrapper d-flex flex-direction-column justify-content-between">
        <div class="">
          <div class="top d-flex justify-content-start">
            <span class="special-network-color font-weight-bold" v-if="!place">
              IN PRIMO PIANO
            </span>
            <div v-else>
              <span v-html="place"></span>
            </div>
          </div>
          <div class="title" v-html="title">
          </div>
          <div class="content" v-html="content"></div>
        </div>
        <a class="network-link" target="_blank" :href="link" v-html="label"></a>
      </div>
    </div>
  </div>
</template>

<script>
  import "@images/pin.png"

  export default {
    name: 'CrowdfundingProjectWidget',
    data(){
      return {
      }
    },
    components:{
    },
    props: {
      title: {
        type: String,
        default: ""
      },
      image: {
        type: String,
        default: ""
      },
      content: {
        type: String,
        default: ""
      },
      label: {
        type: String,
        default: ""
      },
      link: {
        type: String,
        default: ""
      },
      place: {
        type: String,
        default: ""
      }
    },
    computed: {
      widgetStyle(){
        return {
        }
      },
      authorsText(){
        return this.authors.join(", ")
      }
    }
  }
</script>

<style lang="less" scoped>
  @import (reference) '~@less/_variables';
  @import (reference) '~@less/common';
  .CrowdfundingProjectWidget{
    .imgWrapper,
    .infoWrapper{
      flex: 0 1 49.5%;
    }

    .imgWrapper{
      margin-bottom: 10px;
      @media (min-width: @bootstrap-md){
        margin-bottom: 0;
      }
    }

    img{
      display: block;
      max-width: 100%;
    }

    .title{

      font-size: 21px;
      line-height: 28px;
      margin: 5px 0 10px;
      font-weight: 700;

      @media (min-width: @bootstrap-md){
        font-size: 28px;
        line-height: 35px;
        margin: 12px 0 19px;
      }
      
    }

    .top{
      img{
        margin-right: 12px;
        align-self: center;
      }
    }

    .content{
      margin-bottom: 15px;
    }

    .top, .content{
      font-size: 21px;
      line-height: 30px;
    }

    .network-link{
      font-size: 21px;
      &:link, &:visited, &:hover, &:active{
        text-decoration: none;
      }
    }
  }
</style>
